export default "__VITE_ASSET__C916pGuy__"